import React, { useEffect, useState } from "react";
import Aos from "aos";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { all_routes } from "../../router/all_routes";
import { formatDateVerbose, formatTimeVerbose, ListUsersBookings, number_format, S3CDNURL, showBookingStatusLabel, showfulldatetime } from "../../../functionsMaster";

const UserBookingsNew = () => {
  const routes = all_routes;
  const [searchInput, setSearchInput] = useState("");
  const [bookings, setBookings] = useState([]);
  const [cars, setCars] = useState([]);
  const filteredData = bookings.filter((booking) => {
    const values = Object.values(booking).map((value:any) =>
      value.toString().toLowerCase()
    );
    return values.some((value) => value.includes(searchInput.toLowerCase()));
  });
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
    const fetchData = async () => {   
        const res = await ListUsersBookings();
        if (!res.status) {
          alert(res.message);
        }
        if (res.data) {
          setBookings(res.data);
        }
        if (res.cars) {
          setCars(res.cars);
        }
        setCars
    };
    fetchData();
  }, []);
  
  const carName = (res:any) => {
    const carData = cars.find(c => c._id.toString() === res.carID.toString());
    return (
      <div className="table-avatar">
        <Link
          to={`/listings/car/${carData.slug}`}
          target="_BLANK"
          className="avatar avatar-lg flex-shrink-0">
          <img
            className="avatar-img"
             src={`${S3CDNURL}${carData.image}`}
             alt={carData.name}
          />
        </Link>
        <div className="table-head-name flex-grow-1">
          <Link
            to={`/listings/car/${carData.slug}`}
            target="_BLANK"
          >
            {carData.name}
          </Link>
          <p>{res.deliveryStatus}</p>
        </div>
      </div>
    );
  };
  const PickupDateTime = (res:any) => {
    return (
      <p>
        {formatDateVerbose(res.pickUpDate)}
        <span className="d-block">{formatTimeVerbose(res.pickUpTime)}</span>
      </p>
    );
  };

  const ReturnDateTime = (res:any) => {
    return (
      <p>
        {formatDateVerbose(res.dropOffDate)}
        <span className="d-block">{formatTimeVerbose(res.dropOffTime)}</span>
      </p>
    );
  };

  const bookedOn = (res:any) => {
    return (
      <p>{showfulldatetime(res.createdAt)}</p>
    );
  };

  const TotalAmount = (res:any) => {
    const v = Number(res.rentalCharge) + Number(res.pickCharge) + Number(res.rentDepotit);
    return (
      <p>
          <b>{number_format(v, 0, '.', ',')}</b>
          <div className="text-info"><small>Rental Charges: {number_format(res.rentalCharge, 0, '.', ',')}</small></div>
          <div className="text-warning"><small>Pick/ Drop Charges: {number_format(res.pickCharge, 0, '.', ',')}</small></div>
          <div className="text-success"><small>Refundable Deposit: {number_format(res.rentDepotit, 0, '.', ',')}</small></div>
      </p>
    );
  };

  const status = (res:any) => {
    return (
      <span
        className={showBookingStatusLabel(res.status).badgeClass}
      >
        {showBookingStatusLabel(res.status).labelValue}
      </span>
    );
  };
  // const action = () => {
  //   return (
  //     <>
  //       <Link
  //         to="#"
  //         className="btn btn-sm btn-primary"
  //         data-bs-toggle="modal"
  //         data-bs-target="#bookingDetails"
  //       >
  //         <i className="feather icon-eye" /> View
  //       </Link>
  //     </>
  //   );
  // };
 
  return (
    <>
      <div className="content">
        <div className="container">
          {/* Content Header */}
          <div className="content-header">
            <h4>My Bookings</h4>
          </div>
          {/* /Content Header */}
          <div className="row">
            {/* All Bookings */}
            <div className="col-lg-12 d-flex">
              <div className="card book-card flex-fill mb-0">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-md-5">
                      <h4>
                        All Bookings <span>{bookings.length}</span>
                      </h4>
                    </div>
                    <div className="col-md-7 text-md-end">
                      <div className="table-search">
                      <div id="tablefilter">
                          <label className="d-none">
                            <input
                              type="text"
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                              placeholder="Search"
                              className="inputsearch"
                            />
                          </label>
                        </div>
                        <Link to={routes.listingGrid} target="_BLANK" className="btn btn-add">
                          <i className="feather icon-plus-circle" />
                          New Booking
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dashboard-table">
                    <DataTable
                      className="table datatable"
                      value={filteredData}
                      paginator
                      rows={10}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      currentPageReportTemplate="{first}"
                    >
                      <Column
                        field="carName"
                        header="Car Name"
                        body={carName}
                      ></Column>
                      <Column
                        field="deliveryStatus"
                        header="Pickup Date & Time"
                        body={PickupDateTime}
                      ></Column>
                      <Column
                        field="location"
                        header="Return Date & Time"
                        body={ReturnDateTime}
                      ></Column>
                      <Column
                        field="bookedOn"
                        header="Booked On"
                        body={bookedOn}
                      ></Column>
                      <Column
                        field="rentalCharge"
                        header="Total"
                        body={TotalAmount}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        body={status}
                      ></Column>
                      {/* <Column
                        field="action"
                        header="Action"
                        body={action}
                      ></Column> */}
                    </DataTable>
                  </div>
                  <div className="table-footer">
                    <div className="row">
                      <div className="col-md-6">
                        <div id="tablelength" />
                      </div>
                      <div className="col-md-6 text-md-end">
                        <div id="tablepage" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /All Bookings */}
          </div>
          {/* /Dashboard */}
        </div>
      </div>

      {/* Completed Booking */}
      <div
        className="modal new-modal multi-step fade"
        id="bookingDetails"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="booking-header">
                <div className="booking-img-wrap">
                  <div className="book-img">
                    <ImageWithBasePath
                      src="assets/img/cars/car-05.jpg"
                      alt="img"
                    />
                  </div>
                  <div className="book-info">
                    <h6>Chevrolet Camaro</h6>
                    <p>
                      <i className="feather icon-map-pin" /> Location : Miami St,
                      Destin, FL 32550, USA
                    </p>
                  </div>
                </div>
                <div className="book-amount">
                  <p>Total Amount</p>
                  <h6>
                    $4700{" "}
                    <Link to="#">
                      <i className="feather icon-alert-circle" />
                    </Link>
                  </h6>
                </div>
              </div>
              <div className="booking-group">
                <div className="booking-wrapper">
                  <div className="booking-title">
                    <h6>Booking Details</h6>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Booking Type</h6>
                        <p>Delivery</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Rental Type</h6>
                        <p>Days (3 Days)</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Extra Service</h6>
                        <p>Mobile Charging</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Delivery</h6>
                        <p>45, Avenue ,Mark Street, USA</p>
                        <p>11 Jan 2023, 03:30 PM</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Dropoff</h6>
                        <p>78, 10th street Laplace,USA</p>
                        <p>11 Jan 2023, 03:30 PM</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Status</h6>
                        <span className="badge badge-light-success">
                          Completed
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Booked On</h6>
                        <p>15 Sep 2023, 09:30 AM</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Start Date</h6>
                        <p>18 Sep 2023, 09:30 AM</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>End Date</h6>
                        <p>20 Sep 2023, 09:30 AM</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="booking-wrapper">
                  <div className="booking-title">
                    <h6>Personal Details</h6>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Details</h6>
                        <p>Johna Melinda</p>
                        <p>+1 56441 56464</p>
                        <p>Johna@example.com</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>Address</h6>
                        <p>78, 10th street</p>
                        <p>Laplace,USA</p>
                        <p>316 654</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="booking-view">
                        <h6>No of Person’s</h6>
                        <p>2 Adults, 1 Child</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-btn modal-btn-sm text-end"></div>
            </div>
          </div>
        </div>
      </div>
      {/* /Completed Booking */}
    </>
  );
};

export default UserBookingsNew;
